import { useTranslation } from "react-i18next";

export default function AboutPanel() {
  const { t } = useTranslation();
  return (
    <section className="panel" data-side="left" id="story">
      <img
        className="panel-bg"
        src="https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20male%20nurse%20in%20dark%20teal%20scrubs%20sitting%20at%20a%20small%20wooden%20table%20in%20a%20sunlit%20apartment%2C%20writing%20notes%20in%20a%20folder%2C%20soft%20pale%20blue%20white%20walls%2C%20calm%20daylight%2C%20shallow%20depth%20of%20field%2C%20muted%20teal%20and%20navy%20tones%2C%20clinical%20yet%20warm%20atmosphere%2C%20no%20text&width=2400&height=1350&seq=nurse-story-01&orientation=landscape"
        alt={t("story.imageAlt")}
        width={2400}
        height={1350}
        loading="eager"
        fetchPriority="low"
        decoding="async"
        data-parallax="0.32"
      />
      <div className="panel-veil" />
      <div className="panel-copy" data-parallax="-0.08">
        <p className="stamp" data-reveal>{t("story.stamp")}</p>
        <h2 data-reveal dangerouslySetInnerHTML={{ __html: t("story.h2") }} />
        <p className="sub" data-reveal>{t("story.sub")}</p>
        <ul className="num-list">
          {["story.point1", "story.point2", "story.point3"].map((k, i) => (
            <li key={k} data-reveal>
              <span className="idx">0{i + 1}</span>
              <p className="t" style={{ margin: 0 }}>{t(k)}</p>
            </li>
          ))}
        </ul>
        <a className="cta" href="#contact" data-reveal>
          {t("beat1.cta")}
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </a>
      </div>
    </section>
  );
}